import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { ProductTabs } from "@modules/defaultProducts/components/ProductTabs";
import { useProductEditForm } from "@pages/products/edit/controller";

export const ProductEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useProductEditForm();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleDeleteSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ["products"], refetchType: "all" });
    navigate("/products");
  };

  const handleSubmitValues = (data: any) => {
    const metadata: { [key: string]: any } = {}
    data.metadata = Object.values(data.metadata).map((meta: any) => 
      metadata[meta.key] = meta
    )
    data.metadata = metadata
    mutateAsync(data)
  }

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(handleSubmitValues as any),
        loading: isPending,
      }}
      deleteButtonProps={{
        onSuccess: handleDeleteSuccess,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <ProductTabs />
      </FormProvider>
    </Edit>
  );
});


